import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxChartComponent, DxPivotGridComponent } from 'devextreme-angular';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { exportWidgets } from 'devextreme/viz/export';
import { Workbook } from 'exceljs';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { O2PortalHycoReportService } from 'src/app/reports/o2-reports/o2-portal-hyco-report/service/o2-portal-hyco-report-service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-o2-portal-hyco-fiveyr-analysis-report',
  templateUrl: './o2-portal-hyco-fiveyr-analysis-report.component.html',
  styleUrls: ['./o2-portal-hyco-fiveyr-analysis-report.component.scss']
})
export class O2PortalHycoFiveyrAnalysisReportComponent implements OnInit {
  @Input() currentYearMonthsInfo: any;
  @Input() selectedAnnouncementYear: number;
  @Input() selectedReportLinkId: number;
  consolidatedSOGAnnouncementYearDataSource: any;
  fytTonnageBusinessCapitalDataSource: any;
  fyaTonnageBusinessCapitalDataSource: any;

  fytASUCapitalDataSource: any;
  fyaASUCapitalDataSource: any;

  fytHyCOCapitalDataSource: any;
  fyaHyCOCapitalDataSource: any;

  barChartSeriesColors: Map<string, string>;

  fytTBCBillionUSDCapital: string;
  fyaTBCBillionUSDCapital: string;
  fytASUCBillionUSDCapital: string;
  fyaASUCBillionUSDCapital: string;
  fytHyCOCBillionUSDCapital: string;
  fyaHyCOCBillionUSDCapital: string;

  fytPivotGridDataSource: any;
  fyaPivotGridDataSource: any;
  @ViewChild("fytTonnageBusinessCapitalReportChart", { static: false }) dxFYTTBCBarChart: DxChartComponent;
  @ViewChild("fyaTonnageBusinessCapitalReportChart", { static: false }) dxFYATBCBarChart: DxChartComponent;
  @ViewChild("fytAnalysisASUReportChart", { static: false }) dxFYTASUCBarChart: DxChartComponent;
  @ViewChild("fyaAnalysisASUReportChart", { static: false }) dxFYAASUCBarChart: DxChartComponent;
  @ViewChild("fytAnalysisHyCoReportChart", { static: false }) dxFYTHYCOCBarChart: DxChartComponent;
  @ViewChild("fyaAnalysisHyCoReportChart", { static: false }) dxFYAHYCOCBarChart: DxChartComponent;
  @ViewChild('fytPivotGrid', { static: false }) dxFYTPivotGrid: DxPivotGridComponent;
  @ViewChild('fyaPivotGrid', { static: false }) dxFYAPivotGrid: DxPivotGridComponent;

  constructor(private notificationService: NotificationService, private o2PortalHycoReportService: O2PortalHycoReportService) {
    this.customizeLabel = this.customizeLabel.bind(this);
    this.barChartSeriesColors = new Map<string, string>();
  }
  ngOnInit(): void {
    this.getHyCoAnalysisReportData(this.selectedReportLinkId, this.selectedAnnouncementYear);
  }

  onCellPrepared(e) {
    if (e.area === "data" && e.cell.text === "") {
      e.cellElement.textContent = "0";
    }
  }
  customizeLabel(arg) {
  }

  customizePoint = (arg: any) => {
    if (!this.barChartSeriesColors.has(arg.data.businessType)) {
      this.barChartSeriesColors.set(arg.data.businessType, arg.series.pointsByArgument[arg.argument][0].getColor());
    }
    return { color: this.barChartSeriesColors.get(arg.data.businessType), hoverStyle: { color: this.barChartSeriesColors.get(arg.data.businessType) } };
  }

  customizeTooltip(arg: any) {
    return {
      text: `${arg.seriesName} : ${arg.value.toFixed(2).toString()}` + ' USD $MM',
    };
  }

  customizeBillionTooltip(arg: any) {
    return {
      text: `${arg.seriesName} : ${arg.value.toFixed(2).toString()}` + ' Billion USD',
    };
  }

  exportCharts() {

    const dxFYTTBCBarChartInstance = this.dxFYTTBCBarChart.instance;
    const dxFYATBCBarChartInstance = this.dxFYATBCBarChart.instance;
    const dxFYTASUCBarChartInstance = this.dxFYTASUCBarChart.instance;
    const dxFYAASUCBarChartInstance = this.dxFYAASUCBarChart.instance;
    const dxFYTHYCOCBarChartInstance = this.dxFYTHYCOCBarChart.instance;
    const dxFYAHYCOCBarChartInstance = this.dxFYAHYCOCBarChart.instance;

    exportWidgets([[dxFYTTBCBarChartInstance, dxFYATBCBarChartInstance],
    [dxFYTASUCBarChartInstance, dxFYAASUCBarChartInstance],
    [dxFYTHYCOCBarChartInstance, dxFYAHYCOCBarChartInstance]], {
      fileName: "AnnouncedASUHyCOAwards_SOG_5YR",
      format: "PNG"
    });
  }

  exportExcel(e) {
    const context = this;
    const workbook = new Workbook();
    const fytWorkSheet = workbook.addWorksheet("5-Year Total Competitor Investment");
    const fyaWorkSheet = workbook.addWorksheet("5-Year Average Competitor Investment");

    exportPivotGrid({
      worksheet: fytWorkSheet,
      component: context.dxFYTPivotGrid.instance
    }).then(() => {
      exportPivotGrid({
        worksheet: fyaWorkSheet,
        component: context.dxFYAPivotGrid.instance
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AnnouncedASUHyCOAwards_SOG_5YR.xlsx');
        })
      })
    });
  }
  getHyCoAnalysisReportData(_selectedReportLinkId: number, _selectedAnnouncementYear: number) {
    this.o2PortalHycoReportService.getHyCoAnalysisReportData(_selectedReportLinkId, _selectedAnnouncementYear).subscribe({
      next: data => {
        this.consolidatedSOGAnnouncementYearDataSource = data;
        this.barChartSeriesColors.clear();
        this.setDataSource();
      },
      error: (error: any) => {
        this.notificationService.alert("error", "Error while fetching HyCoAnalysis Report data", error);
      }
    });
  }
  setDataSource() {
    // 5 Year  - Tonnage Business Data Calculation
    let fytData = this.consolidatedSOGAnnouncementYearDataSource.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    let capitalTotalInMillion = 0.0;
    // Deep Clone
    this.fytTonnageBusinessCapitalDataSource = JSON.parse(JSON.stringify(fytData))
    this.fytTonnageBusinessCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.fytTBCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(1) + " Billion USD";
    this.fytTonnageBusinessCapitalDataSource = this.fytTonnageBusinessCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.offeringType == item.offeringType);
      if (accItem) {
        accItem.competitorInvestment = accItem.competitorInvestment + item.competitorInvestment / 1000;
      } else {
        accm.push(item);
      }

      return accm;
    }, []);

    // 5 Year Average  - Tonnage Business Data Calculation
    capitalTotalInMillion = 0.0;
    this.fyaTonnageBusinessCapitalDataSource = JSON.parse(JSON.stringify(fytData));
    this.fyaTonnageBusinessCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });
    this.fyaTBCBillionUSDCapital = (capitalTotalInMillion / 1000 / 5).toFixed(1) + " Billion USD";

    this.fyaTonnageBusinessCapitalDataSource = this.fyaTonnageBusinessCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.offeringType == item.offeringType);
      if (accItem) {
        accItem.competitorInvestment = accItem.competitorInvestment + item.competitorInvestment / 5;
      } else {
        item.competitorInvestment = item.competitorInvestment / 5;
        accm.push(item);
      }
      return accm;
    }, []);

    // 5 Year  - ASU Capital Data Calculation
    let fytASUData = fytData.filter(x => x.offeringType == 'ASU');
    fytASUData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    capitalTotalInMillion = 0.0;
    this.fytASUCapitalDataSource = JSON.parse(JSON.stringify(fytASUData));
    this.fytASUCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.fytASUCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(1) + " Billion USD";
    this.fytASUCapitalDataSource = this.fytASUCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.offeringType == item.offeringType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment) / 1000;
      } else {
        accm.push(item);
      }

      return accm;
    }, []);

    // 5 Year Average  - ASU Data Calculation
    let fyaASUData = fytData.filter(x => x.offeringType == 'ASU');
    fyaASUData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    this.fyaASUCapitalDataSource = JSON.parse(JSON.stringify(fyaASUData));
    capitalTotalInMillion = 0.0;
    this.fyaASUCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.fyaASUCBillionUSDCapital = (capitalTotalInMillion / 1000 / 5).toFixed(1) + " Billion USD";
    this.fyaASUCapitalDataSource = this.fyaASUCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.offeringType == item.offeringType);
      if (accItem) {
        accItem.competitorInvestment = accItem.competitorInvestment + item.competitorInvestment / 5;
      } else {
        item.competitorInvestment = item.competitorInvestment / 5;
        accm.push(item);
      }

      return accm;
    }, []);


    // 5 Year  - HyCO Capital Data Calculation
    let fytHyCOData = fytData.filter(x => x.offeringType == 'HyCO');
    fytHyCOData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    capitalTotalInMillion = 0.0;
    this.fytHyCOCapitalDataSource = JSON.parse(JSON.stringify(fytHyCOData));
    this.fytHyCOCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.fytHyCOCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(1) + " Billion USD";
    this.fytHyCOCapitalDataSource = this.fytHyCOCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.offeringType == item.offeringType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment) / 1000;
      } else {
        accm.push(item);
      }

      return accm;
    }, []);

    // 5 Year Average  - HyCO Data Calculation
    let fyaHyCOData = fytData.filter(x => x.offeringType == 'HyCO');
    fyaHyCOData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    capitalTotalInMillion = 0.0;
    this.fyaHyCOCapitalDataSource = JSON.parse(JSON.stringify(fyaHyCOData));
    this.fyaHyCOCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.fyaHyCOCBillionUSDCapital = (capitalTotalInMillion / 1000 / 5).toFixed(1) + " Billion USD";
    this.fyaHyCOCapitalDataSource = this.fyaHyCOCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.offeringType == item.offeringType);
      if (accItem) {
        accItem.competitorInvestment = accItem.competitorInvestment + item.competitorInvestment / 5;
      } else {
        item.competitorInvestment = item.competitorInvestment / 5;
        accm.push(item);
      }

      return accm;
    }, []);

    this.fytPivotGridDataSource = {
      fields: [{
        caption: 'Total 5-Yr Investment Billion USD',
        width: 120,
        dataField: 'offeringType',
        area: 'row',
      }, {
        dataField: 'competitor',
        area: 'column',
      }, {
        groupName: 'offeringType',
        visible: true,
      }, {
        caption: 'Total',
        dataField: 'competitorInvestment',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.fytTonnageBusinessCapitalDataSource
    }

    this.fyaPivotGridDataSource = {
      fields: [{
        caption: 'Avg 5-Yr Investment Million USD',
        //width: 120,
        dataField: 'offeringType',
        area: 'row',
      }, {
        dataField: 'competitor',
        area: 'column',
      }, {
        groupName: 'offeringType',
        visible: true,
      }, {
        caption: 'Total',
        dataField: 'competitorInvestment',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.fyaTonnageBusinessCapitalDataSource
    }
  }
}
